import { IconAlertTriangle } from "@tabler/icons-react";
import { useRef } from "react";
import { trackDpiCalculated, trackLowDpiWarningShown } from "@/lib/analytics/segment";
import { usePdpStore } from "@/stores/usePdpStore";
import { LowDpiHelper } from "@/utils/LowDpiHelper";
export default function LowDpiWarning() {
  const imageWidth = usePdpStore(s => s.imageWidth);
  const imageHeight = usePdpStore(s_0 => s_0.imageHeight);
  const sizeWidth = usePdpStore(s_1 => s_1.width);
  const sizeHeight = usePdpStore(s_2 => s_2.height);
  const filename = usePdpStore(s_3 => s_3.uploadedFileInfo?.filename);
  const trackedDpiRef = useRef<number | undefined>(undefined);
  const trackedWarningRef = useRef(false);
  const isVector = LowDpiHelper.isVectorImage(filename);
  const dpi = isVector ? undefined : LowDpiHelper.calculateDpi({
    widthPixels: imageWidth,
    heightPixels: imageHeight,
    widthInches: sizeWidth,
    heightInches: sizeHeight
  });
  if (dpi !== undefined && trackedDpiRef.current !== dpi && imageWidth && imageHeight && sizeWidth && sizeHeight) {
    trackedDpiRef.current = dpi;
    trackDpiCalculated({
      dpi,
      widthPixels: imageWidth,
      heightPixels: imageHeight,
      widthInches: Number(sizeWidth),
      heightInches: Number(sizeHeight),
      pageType: "pdp"
    });
  }
  const warningText = LowDpiHelper.getDpiText(dpi);
  if (!warningText) return null;
  if (!trackedWarningRef.current && dpi !== undefined) {
    trackedWarningRef.current = true;
    trackLowDpiWarningShown(dpi, warningText);
  }
  return <div className="flex items-start gap-3 rounded-lg border border-input bg-background p-3">
      <IconAlertTriangle size={20} aria-hidden="true" className="shrink-0 text-destructive" />
      <div className="flex-1">
        <p className="text-sm font-medium text-foreground mb-1">Warning</p>
        <p className="text-xs text-muted-foreground">
          {warningText}
          <a href="https://support.stickergiant.com/hc/en-us/articles/26487201264276-What-is-Artwork-Resolution" className="shrink-0 ml-1 font-medium text-destructive hover:underline" target="_blank" rel="noreferrer">
            Learn more<span className="sr-only"> about artwork resolution</span>
          </a>
        </p>
      </div>
    </div>;
}